import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { SelectItem } from 'primereact/selectitem';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import { Labelled, LabelledProps } from './Labelled';

interface Props extends LabelledProps {
  value: any;
  onChange: (value: any) => void;
  options: SelectItem[];
  autoFocus?: boolean;
  className?: string;
  display?: 'chip' | 'comma';
  appendTo?: 'self' | HTMLElement | undefined | null | (() => HTMLElement);
}

export const LabelledMultiSelect = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <MultiSelect
        id={props.id}
        appendTo={props.appendTo}
        value={props.value}
        filter={true}
        display={props.display}
        required={props.permissions?.required || props.required}
        invalid={props.validation ? !props.validation?.valid : false}
        disabled={disabled}
        options={props.options}
        onChange={(e: MultiSelectChangeEvent): void => props.onChange(e.target.value)}
        autoFocus={props.autoFocus}
        className={props.className}
        showClear={(props.permissions ? !props.permissions?.required : true)}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
